import deepmerge from 'deepmerge';

import ED from '../../bluestone/ED';
import type { Colors } from '../../types';
import baseColors from './base/ED';
import deprecatedColors from './deprecated';
import derivedColors from './derived/ED';

const colors: Colors = {
  ...ED.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.secondary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
